export default __webpack_public_path__ + "static/media/animated_logo.e416d35d.svg";